module.exports = __webpack_public_path__ + "static/media/codewindow.0f6fa8c3.png";